// extracted by mini-css-extract-plugin
module.exports = {"Background":"Background_Background__1d8X3"};